export default __webpack_public_path__ + "5e0e3af.png";